module.exports = __webpack_public_path__ + "img/icon_3.7de1eb33.png";